/** Room exchange pages must not load third-party monitoring or leak invite metadata. */
export function isRoomPrivacyPath(pathname: string): boolean {
  return pathname === "/room-invite" || pathname === "/rooms" || pathname.startsWith("/rooms/");
}

export function protectRoomReferrer(target: Document = document): void {
  let meta = target.querySelector<HTMLMetaElement>('meta[name="referrer"]');
  if (!meta) {
    meta = target.createElement("meta");
    meta.name = "referrer";
    target.head.prepend(meta);
  }
  meta.content = "no-referrer";
}
